import { avatarAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { textStyles } from "../../../../theme/foundations/generated";
import { AvatarVariant } from "../Avatar.type";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(avatarAnatomy.keys);
const baseStyle = definePartsStyle({
    container: Object.assign(Object.assign({ width: "8", height: "8" }, textStyles.body.largeBold), { borderRadius: "2px", backgroundColor: "semantic.brand.secondary", color: "semantic.text.primary" }),
});
const variants = {
    [AvatarVariant.BO]: definePartsStyle({
        container: {
            backgroundColor: "semantic.brand.tertiary",
        },
    }),
};
const AvatarTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: { size: "default" },
});
export default AvatarTheme;
//# sourceMappingURL=Avatar.default.js.map